import {
  Box,
  Flex,
  Image,
  Button,
  useColorModeValue,
  Center,
  Wrap,
  WrapItem,
  useColorMode,
  Spacer,
  Heading,
  Tooltip,
  useDisclosure,
  Link,
  LinkBox,
  LinkOverlay,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Stack,
  Text,
  HStack,
  VStack,
  Collapse,
  IconButton
} from "@chakra-ui/react";

import Logo from "../images/logo.webp";
import { FaDiscord, FaTwitter } from "react-icons/fa";
import { ChevronDownIcon, CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import {
  Link as RouterLink,
} from "react-router-dom";

interface HeaderNavigationProps {
  isConnected: boolean
  account: string | undefined
  isCorrectChainId: boolean
  toggleConnect: () => void
  switchNetwork: () => void
}
interface NavItem {
  label: string;
  children?: Array<NavItem>;
  href?: string;
  isExternal?: boolean;
}

const HeaderNavigation: React.FC<HeaderNavigationProps> = (props) => {
  const account = props.account

  const handleTwitterClick = () => {
    window.open("https://twitter.com/CronosMoney");
  }

  const handleDiscordClick = () => {
    window.open("https://t.co/ZWWBhLPRSl");
  }

  const { isOpen, onToggle, onClose } = useDisclosure();

  const NAVIGATION_ITEMS: Array<NavItem> = [
    {
      label: 'Mint',
      href: '/',
    },
    {
      label: 'My NFTs',
      href: 'nfts'
    },
    {
      label: 'Rewards',
      href: '/rewards',
    },
    {
      label: 'Buy',
      children: [
        {
          label: 'Ebisu\'s Bay',
          href: 'https://app.ebisusbay.com/collection/cmm-membership-card',
          isExternal: true,
        },
        {
          label: 'Minted',
          href: 'https://minted.network/collections/cronos/0xb038277515756fb56ba694d2ad702e8e0290c826',
          isExternal: true,
        },
        {
          label: 'Moonflow',
          href: 'https://moonflow.club/collection/crypto-money-makers-membership-card',
          isExternal: true,
        },
      ],
    },
    {
      label: 'Partners',
      href: '/partners',
    },
  ]

  const items = <>
    {NAVIGATION_ITEMS.map((navItem) => (
      <Box key={navItem.label}>
        {navItem.children
          ?
          <>
            <Menu>
              <MenuButton as={Button} variant={'ghost'} textColor={'rgb(218, 165, 32)'} fontSize={'2xl'} rightIcon={navItem.children ? <ChevronDownIcon /> : null}>
                {navItem.label}
              </MenuButton>
              <MenuList
                bgColor={"gray.900"}
                borderColor={"gray.900"}
              >
                {navItem.children.map((child, index) => (
                  <MenuItem key={index} _focus={{}} onClick={() => {
                    onClose();
                  }}>
                    <SubNav key={child.label} {...child} />
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          </>
          :
          <RouterLink to={navItem.href ?? '#'}>
            <Button textColor={'rgb(218, 165, 32)'} fontSize={'2xl'} onClick={() => {
              onClose();
            }} variant={'ghost'}>{navItem.label}</Button>
          </RouterLink>}
      </Box>
    ))}
  </>

  const desktopNavigation = <>
    <Stack direction={'row'} spacing={2} display={{ base: 'none', md: 'flex' }}>
      <Wrap>
        {items}
      </Wrap>
    </Stack>
  </>

  const mobileNavigation = <>
    <Stack
      fontFamily={"Sedgwick Ave Display"}>
      {items}
    </Stack>
  </>

  const buttons = <>
    <HStack>
      <HStack>
        <Button color={'rgb(218, 165, 32)'} variant={'solid'} size='sm' onClick={handleDiscordClick}>
          {<FaDiscord />}
        </Button>

        <Button color={'rgb(218, 165, 32)'} variant={'solid'} size='sm' onClick={handleTwitterClick}>
          {<FaTwitter />}
        </Button>
      </HStack>
      <HStack>
        <Tooltip label={account ? `${account.slice(0, 6)}...${account.slice(-4)}` : null}>
          <Button size={'md'} color={'rgb(218, 165, 32)'} onClick={props.toggleConnect}>
            {props.isConnected ? "Disconnect" : "Connect Wallet"}
          </Button>
        </Tooltip>
      </HStack>
    </HStack>
  </>

  const menu = <>
    <IconButton
      display={{ base: 'flex', md: 'none' }}
      onClick={onToggle}
      icon={
        isOpen ? <CloseIcon color={'rgb(218, 165, 32)'} w={3} h={3} /> : <HamburgerIcon color={'rgb(218, 165, 32)'} w={5} h={5} />
      }
      variant={'ghost'}
      aria-label={'Toggle Navigation'}
    />
    <VStack display={{ base: 'flex', md: 'none' }}>
      <HStack>
        <Collapse in={isOpen} animateOpacity>
          {mobileNavigation}
        </Collapse>
        <Spacer />
      </HStack>
      <Image src={Logo} w={'136px'} h={'60px'} objectFit='contain' mt={4} />
      {buttons}
    </VStack>
    <Image display={{ base: 'none', md: 'flex' }} src={Logo} w={'136px'} h={'60px'} objectFit='contain' mt={4} />
    <Spacer display={{ base: 'none', md: 'flex' }} />
    <Stack display={{ base: 'none', md: 'flex' }} direction={['column', 'row']} textColor={'rgb(218, 165, 32)'} fontFamily={"Sedgwick Ave Display"} my={8} px={8} >
      {desktopNavigation}
    </Stack >
    <Spacer display={{ base: 'none', md: 'flex' }} />
    <Box display={{ base: 'none', md: 'flex' }}>
      {buttons}
    </Box>
  </>

  return (
    <>
      <Box mt={4} pb={{ base: 2, md: 0 }} mx={8} px={4} borderRadius={'2xl'} css={{
        border: '2px solid rgb(218, 165, 32)'
      }}>
        <Flex py={4}>
          {menu}
        </Flex>
      </Box>
    </>
  );
  // 
  // return (
  //   <>
  //     <Box
  //       minW={360}
  //       mx={4}
  //       mb={4}
  //       bg={useColorModeValue("gray.50", "gray.900")}
  //       rounded={"xl"}
  //       boxShadow={"md"}
  //       sx={{ position: "sticky", top: "4", zIndex: "999" }}
  //       px={4}
  //     >
  //       <LinkBox as={RouterLink} to={'/'}>
  //         <Center py={4} fontWeight={"bold"}>
  //           <Heading fontSize={{ base: 'xl', md: '2xl' }}>Baby Monsters</Heading>
  //         </Center>
  //       </LinkBox>
  //       <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>
  //         <IconButton
  //           onClick={onToggle}
  //           display={{ base: 'flex', md: 'none' }}
  //           icon={
  //             isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
  //           }
  //           variant={'ghost'}
  //           aria-label={'Toggle Navigation'}
  //         />

  //         <Flex display={{ base: 'none', md: 'flex' }} py={4}>
  //           {desktopNavigation}
  //         </Flex>
  //         <Spacer />

  //         <VStack py={2}>
  //           <Stack
  //             direction={'row'}
  //             spacing={2}>
  //             <Button size='xs' onClick={handleDiscordClick}>
  //               {<FaDiscord />}
  //             </Button>

  //             <Button size='xs' onClick={handleTwitterClick}>
  //               {<FaTwitter />}
  //             </Button>
  //           </Stack>

  //           <HStack>
  //             <Tooltip label={account ? `${account.slice(0, 6)}...${account.slice(-4)}` : null}>
  //               <Button size={'sm'} onClick={props.toggleConnect}>
  //                 {props.isConnected ? "Disconnect" : "Connect Wallet"}
  //               </Button>
  //             </Tooltip>
  //           </HStack>
  //         </VStack>
  //       </Flex>

  //       <Collapse in={isOpen} animateOpacity>
  //         {mobileNavigation}
  //       </Collapse>
  //     </Box>
  //   </>
  // )
};

const SubNav = ({ label, href, isExternal }: NavItem) => {
  const link = <>
    <Box>
      <Text p={2}
        fontSize={'xl'}
        transition={'all .3s ease'}
        _hover={{ color: 'orange' }}
        fontWeight={400}>
        {label}
      </Text>
    </Box>
  </>

  if (isExternal) {
    return (
      <Link
        style={{ textDecoration: 'none' }}
        isExternal
        href={href ?? "#"}
      >
        {link}
      </Link>
    );
  }
  else {
    return (
      <RouterLink
        to={href ?? "#"}
      >
        {link}
      </RouterLink>
    );
  }
};

export default HeaderNavigation;
